import { Coordinates } from "../../Util/Math/Coordinates"
import { useNoteCtrlMenuCoordinates, useNoteCtrlMenuIsOpen, useNoteCtrlMenuSetMap, useCtrlNote, useNoteCtrlMenuStore } from "./NoteCtrlMenuStore"
import { ControlledMenu, MenuItem, SubMenu } from "@szhsin/react-menu"
import { Note } from "../../Data/HexMap/Note"
import { produce } from "immer"
import { HexMap } from "../../Data/HexMap/HexMap"
import { HexMapModifier } from "../../Data/HexMap/HexMapModifier"
import { NoteCtrlMenuState } from "./NoteCtrlMenuState"

export function NoteCtrlMenu(){
    const coords:Coordinates = useNoteCtrlMenuCoordinates()
    const setIsOpen:Function = useNoteCtrlMenuStore((state:NoteCtrlMenuState)=>state.setIsOpen)
    let note:Note|null = useCtrlNote()
    const setMap:Function = useNoteCtrlMenuSetMap()
    const hideNote = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(note !== null){
              mod.notes_setVisible([note.params.noteIndex], false)
            }
        })) 
        setIsOpen(false)
    }
    const toggleDefined = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(note !== null){
              mod.notes_setDefined([note.params.noteIndex], !note.defined)
            }
        })) 
        setIsOpen(false)
    }
    const setSelectedState = (state:number) => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(note !== null){
              mod.notes_setSelectedState([note.params.noteIndex], state)
            }
        })) 
        setIsOpen(false)
    }    
    const ghost = () => {
        setMap(produce((draft:HexMap)=>{
            const mod:HexMapModifier = new HexMapModifier(draft)
            mod.setDraft(draft)
            if(note !== null){
              mod.notes_toggleClasses([note.params.noteIndex], ['ghosted'])
            }
        })) 
        setIsOpen(false)
    }
    return <div className={'note-ctrl-menu'}>
    <ControlledMenu
        anchorPoint={{x:coords.x,y:coords.y}}
        state={useNoteCtrlMenuIsOpen() ? 'open' : 'closed'}
        direction="right"
        onClose={() => {setIsOpen(false)}}
      >
        <MenuItem onClick={toggleDefined}>Toggle Defined</MenuItem>
        <SubMenu label={'Selected State'}>
          <MenuItem onClick={()=>{setSelectedState(Note.SelectedState_Default)}}>Default</MenuItem>
          <MenuItem onClick={()=>{setSelectedState(Note.SelectedState_Selected)}}>Selected</MenuItem>
          <MenuItem onClick={()=>{setSelectedState(Note.SelectedState_Hilited)}}>Highlighted</MenuItem>
        </SubMenu>
        <MenuItem onClick={ghost}>Ghost/Unghost</MenuItem>
        <MenuItem onClick={hideNote}>Hide</MenuItem>
      </ControlledMenu>
    </div>
}